import { render, staticRenderFns } from "./profile-login.vue?vue&type=template&id=e664c65a&"
import script from "./profile-login.vue?vue&type=script&lang=js&"
export * from "./profile-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports